import { Link, Outlet } from "react-router";
import { Logo } from "../brand";
import { s } from "../strings";
import styles from "./OtherLayouts.module.css";

/** Privacy, terms, unsubscribe: no session needed, minimal header. */
export function StaticLayout() {
  return (
    <div className={styles.static}>
      <header className={styles.staticHeader}>
        <Link to="/" aria-label="Home">
          <Logo size={28} />
        </Link>
        <nav className={styles.staticNav}>
          <Link to="/login">Log in</Link>
          <Link to="/signup">Sign up</Link>
        </nav>
      </header>
      <main className={styles.staticMain}>
        <Outlet />
      </main>
    </div>
  );
}

/** Full-screen kiosk frame (kiosk-activity spec section 6); the kiosk module fills it. */
export function KioskLayout() {
  return (
    <div className={styles.kiosk}>
      <Outlet />
    </div>
  );
}

/** Public shared-report frame: logo + report header, no workspace chrome (reports-other spec). */
export function SharedReportLayout() {
  return (
    <div className={styles.shared}>
      <header className={styles.sharedHeader}>
        <Logo size={28} />
      </header>
      <main className={styles.sharedMain}>
        <Outlet />
      </main>
    </div>
  );
}

/** Bare page with no chrome (extension login hand-off, logout, error). */
export function HandoffLayout() {
  return (
    <div className={styles.handoff}>
      <Outlet />
    </div>
  );
}

export function KioskPending() {
  return <p className={styles.pending}>{s.kioskPending}</p>;
}

export function SharedReportPending() {
  return <p className={styles.pending}>{s.sharedReportPending}</p>;
}
